// 商品管理
export default [
  {
    path: "/product",
    name: 'product',
    meta: { title: "商品管理" },
    component: () => import("../views/product/index.vue"),
    children: [
      {
        path: "/product/productLibrary",
        meta: { title: "商品库", isMenu: true },
        component: () => import("../views/product/productLibrary.vue"),
      },
      {
        path: "/product/detail/apply",
        meta: { title: "上传新商品" },
        component: () => import("../views/product/detail/apply"),
      },
      {
        path: "/product/categoryList",
        meta: { title: "商品分类", isMenu: true },
        component: () => import("../views/product/categoryList.vue"),
      },

      {
        path: "/product/feeSetting",
        meta: { title: "费用设置", isMenu: true },
        component: () => import("../views/product/feeSetting.vue"),
      },
    ],
  },
]
